import React from 'react';
import './mainpg.css';
import videoFile from '../../../assets/mainlvd/landdvd1.mp4';

const HeroLanding = () => {
  const handlePrimaryAction = (event) => {
    event.preventDefault();
    window.location.href = '/save';
  };

  const handleSecondaryAction = (event) => {
    event.preventDefault();
    window.location.href = '/finlit';
  };

  const handletertuaryAction = (event) => {
    event.preventDefault();
    window.location.href = '/builder';
  };

  return (
    <div className="hero-landing-wrapper">
      <div className="hero-landing-container">
        
        {/* Content Section */}
        <div className="hero-content-section">
          <div className="hero-text-content">
            <h1 className="hero-primary-heading">
              Single stop for<br/>
              all of your<br/>
              Finances.
            </h1>
            
            <p className="hero-description">
              Explore and experience the independent journey<br/> 
              you always imagine.
            </p>
            
            <div className="hero-actions-container">
              <button 
                className="hero-primary-btn" 
                onClick={handlePrimaryAction}
                aria-label="Learn more about our financial services"
              >
                <div className="hero-btn-background"></div>
                <div className="hero-btn-circle">
                  <div className="hero-btn-arrow"></div>
                </div>
                <span className="hero-btn-text">Learn More</span>
              </button>
              
              <div className="hero-secondary-row">
              <button 
                className="hero-secondary-btn" 
                onClick={handleSecondaryAction}
                aria-label="Start your Financial journey Now"
              >
                START NOW
              </button>
              
              <button 
                className="hero-secondary-btn" 
                onClick={handletertuaryAction}
                aria-label="Try SOMFINN Build Financial Foundations"
              >
                Try SOMFIN BFF
              </button>
              </div>

            </div>
          </div>
        </div>

        {/* Video Section */}
        <div className="hero-video-section">
          <div className="hero-video-container">
            <video 
              className="hero-video-element"
              autoPlay 
              muted 
              loop 
              playsInline
              src={videoFile}
              aria-label="Financial services demonstration video"
            >
              Your browser does not support the video tag.
            </video>
          </div>
        </div>

      </div>
    </div>
  );
};

export default HeroLanding;